import styled from "styled-components";

const DriverFormWrapper = styled.div`
  .input-wrapper {
    background: #FFFFFF;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    padding: 0 17px;
    display: flex;
    flex-direction: row;
    margin: 0 10px;
    align-items: center;
    i {
      color: #6B47F5;
      width: 10%;
    }
  }
  .button-clear {
    background: transparent;
    color: #4C565C;
    border: none;
    &:hover {
      background: transparent !important;
      color: #4C565C;
    }
  }
  .input-control {
    color: #9AA2AF;
    border: none;
    width: 90%;
    &:focus, &:focus-within, &:focus-visible {
      box-shadow: none !important;
    }
  }
`;

export default DriverFormWrapper;
